import defaults from '../config/default/config.json';
import configConnect from 'preconf';

const configure = configConnect('notificationsConfig', defaults);
export { defaults, configure };
